import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting} from '@/services/settings/Settings.types';
import {IApiService} from '@/services/IApi.service';

@Module({name: 'DashboardStore', namespaced: true})
export class DashboardStore extends VuexModule {

  @Inject(Symbol.for('ISettingsService'))
  public settingsService!: ISettingsService;

  private disabledWidgets: string[] | null = null;

  private widgetsOrder: string[] | null = null;

  private widgets = [
    'lora-forwarder-run-status-widget',
    'network-status-widget',
    'system-upgrade-widget',
    'system-info-widget',
    'system-disk-usage-widget',
    'system-changes-widget',
  ];

  /* Widgets order */
  @Action({commit: 'setWidgetsOrder', rawError: true})
  public loadWidgetsOrder() {

    const order = this.settingsService.get(Setting.WidgetsOrder);

    if (order instanceof String) {
      return order.split(',');
    }

    return [];
  }

  @Action({commit: 'setWidgetsOrder', rawError: true})
  public persistWidgetsOrder(widgets: string[]) {
    this.settingsService.set(Setting.WidgetsOrder, widgets);
    return widgets;
  }

  @Mutation
  public setWidgetsOrder(widgets: string[]) {
    this.widgetsOrder = widgets;
  }

  get WidgetsOrder(): string[] | null {
    return this.widgetsOrder;
  }

  /* Disabled widgets */
  @Action({commit: 'setDisabledWidgets', rawError: true})
  public loadDisabledWidgets() {

    const widgets = this.settingsService.get(Setting.WidgetsDisabled);

    if (widgets instanceof String) {
      return widgets.split(',');
    }

    return [];
  }

  @Action({commit: 'setDisabledWidgets', rawError: true})
  public persistDisabledWidgets(widgets: string[]) {
    this.settingsService.set(Setting.WidgetsDisabled, widgets);
    return widgets;
  }

  @Mutation
  public setDisabledWidgets(widgets: string[]) {
    this.disabledWidgets = widgets;
  }

  get DisabledWidgets(): string[] {
    if (this.disabledWidgets) {
      return this.disabledWidgets;
    } else {
      return [];
    }
  }

  get EnabledWidgets(): string[] {
    return this.widgets
      .filter((w: string) => !this.DisabledWidgets.includes(w))
      .sort((a: string, b: string) => {
        const apos = this.WidgetsOrder?.includes(a) ? this.WidgetsOrder.indexOf(a) : 100 ?? 100;
        const bpos = this.WidgetsOrder?.includes(b) ? this.WidgetsOrder.indexOf(b) : 100 ?? 100;

        return apos - bpos;
      });
  }
}
